var _ref2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTouch = function SvgTouch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 15.716,
    height: 23.074,
    viewBox: "0 0 15.716 23.074",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2 || (_ref2 = React.createElement("g", {
    id: "Group_8582",
    "data-name": "Group 8582",
    transform: "translate(0.5 0.5)"
  }, React.createElement("path", {
    id: "Union_162",
    "data-name": "Union 162",
    d: "M9.754,17.618H3a3.5,3.5,0,0,1-3.5-3.5V11.109a3.51,3.51,0,0,1,.981-2.43V1.472a1.972,1.972,0,0,1,3.944,0v3.24a1.971,1.971,0,0,1,2.8.988,1.97,1.97,0,0,1,2.943.9,1.97,1.97,0,0,1,3.083,1.63v5.886A3.5,3.5,0,0,1,9.754,17.618ZM2.452.5a.973.973,0,0,0-.971.972V8.889a.5.5,0,0,1-.163.37A2.507,2.507,0,0,0,.5,11.109v3.009a2.5,2.5,0,0,0,2.5,2.5H9.754a2.5,2.5,0,0,0,2.5-2.5V8.231a.975.975,0,0,0-1.946-.084.5.5,0,0,1-1-.042V7.328a.971.971,0,1,0-1.943,0v.78a.5.5,0,0,1-1,0V6.427a.971.971,0,1,0-1.943,0V8.108a.5.5,0,0,1-1,0V1.472A.973.973,0,0,0,2.452.5Z",
    transform: "translate(1.962 2.252)",
    fill: "#3c3c3b"
  }), React.createElement("g", {
    id: "Group_8574",
    "data-name": "Group 8574",
    transform: "translate(1.962 19.371)"
  }, React.createElement("path", {
    id: "Union_161",
    "data-name": "Union 161",
    d: "M1.351-.5H11.4a1.851,1.851,0,0,1,0,3.7H1.351a1.851,1.851,0,0,1,0-3.7ZM11.4,2.2a.851.851,0,0,0,0-1.7H1.351a.851.851,0,0,0,0,1.7Z",
    transform: "translate(0 0)",
    fill: "#3c3c3b"
  })), React.createElement("path", {
    id: "Path_7032",
    "data-name": "Path 7032",
    d: "M-18947.59,9204.025a.5.5,0,0,1-.322-.117,4.415,4.415,0,0,1-1.588-3.354,4.728,4.728,0,0,1,4.867-4.553,4.717,4.717,0,0,1,4.961,4.553,3.874,3.874,0,0,1-.344,1.716.5.5,0,0,1-.684.182.5.5,0,0,1-.184-.684,3.1,3.1,0,0,0,.211-1.214,3.727,3.727,0,0,0-3.961-3.553,3.739,3.739,0,0,0-3.867,3.553,3.408,3.408,0,0,0,1.232,2.588.5.5,0,0,1,.061.7A.5.5,0,0,1-18947.59,9204.025Z",
    transform: "translate(18949 -9196.502)",
    fill: "#3c3c3b"
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTouch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/touch.9ba524e5.svg";
export { ForwardRef as ReactComponent };